import { useEffect, useState } from "react";
import BOMService from "../../../../../services/Production/BOMService";
import DataTableBOMDetails from "./DataTableBOMDetails";
import DataTableOperationsDetails from "./DataTableOperationsDetails";
import withLoader from "../../../../../components/layouts/WithLoader";

const BOMDetails = ({ startLoading, stopLoading }) => {
  const [boms, setBoms] = useState(null);
  useEffect(() => {
    startLoading();
    BOMService.getBOMById(localStorage.getItem("idBOM"))
      .then((response) => {
        console.log("getBOMById", response);
        setBoms(response.data.success);
      })
      .catch((e) => {
        console.log("error", e)
        alert("problème de connexion");
      }).finally(() => {
        stopLoading();
      });
  }, []);
  return (
    boms !== null && (<div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div class="card">
            <div class="card-header  ">
              <h3 class="card-title">{boms?.code}-{boms?.state}</h3>
              <label></label>
              <br />
              <label>
                {boms?.product?.productCode}-{boms?.product?.name}
              </label>
              <br />
              <label>
                {boms?.quantity} {boms.unitOfMeasure?.code}-
                {boms?.unitOfMeasure?.name}
              </label>
              <br />
              <label>Les composants</label>
              <DataTableBOMDetails listBOM={boms?.componentList} />
              {
                boms?.dechetList != null && <><label>Les déchets</label>
                  <DataTableBOMDetails listBOM={boms?.dechetList} /></>
              }
              <label>Les opérations</label>
              <DataTableOperationsDetails listOperation={boms?.operations} />
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  );
};
export default withLoader(BOMDetails);
